import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import axios from "axios";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  GetTranslationsListRequest,
  TranslationClient,
} from "../api/TranslationClient";
import { REACT_APP_PORTAL_API_URL } from "../../KeyVariables";

const getLanguageId = (language) => {
  switch (language) {
    case "eng":
      return 2;
    case "ro":
      return 1;
    case "ru":
      return 3;
    default:
      return 1;
  }
};

const fetchTranslations = async (language, namespace, key) => {
  const body = {
    LanguageId: getLanguageId(language),
    Module: namespace,
    Key: key || "",
  } as any;

  const response = await new TranslationClient(REACT_APP_PORTAL_API_URL).list(body);
  const translations = {};

  response.forEach((item) => {
    if (item.translations && item.translations.length > 0) {
      translations[item.key!] = item.translations[0].translation;
    }
  });

  return translations;
};

const customBackend = {
  type: "backend",
  init: function (services, backendOptions, i18nextOptions) {},

  read: async function (language, namespace, callback) {
    try {
      const translations = await fetchTranslations(language, namespace, "");
      callback(null, translations);
    } catch (error) {
      console.error(`[i18n] Error loading translations:`, error);
      callback(error, false);
    }
  },
};

i18n
  .use(customBackend as any)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "ro",
    debug: false,
    ns: ["Common"],
    defaultNS: "Common",
    saveMissing: true,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
